export const GET_COLOR = "GET_COLOR";
export const SET_COLOR = "SET_COLOR";
